import React from "react";
import NoMatch from "./NoMatch";

export interface RouteInfo {
    path: string,
    component: any,
    routes?: RouteInfo[],
    lazy?: boolean,
    protected?: boolean
}

const ReactLazyPreload = (importStatement: any) => {
    const Component: any = React.lazy(importStatement);
    Component.preload = importStatement;
    return Component;
};

const Dashboard = ReactLazyPreload(() => import('./pages/dashboard/Dashboard'));
Dashboard.preload();
const ChangePasswords = ReactLazyPreload(() => import('./pages/settings/change-password/ChangePassword'));
ChangePasswords.preload();
const MyAccount = ReactLazyPreload(() => import('./pages/settings/my-account/MyAccount'));
MyAccount.preload();
const SystemUserForm = ReactLazyPreload(() => import('./pages/system-user/SystemUserForm'));
SystemUserForm.preload();
const SystemUser = ReactLazyPreload(() => import('./pages/system-user/SystemUser'));
SystemUser.preload();
const Role = ReactLazyPreload(() => import('./pages/role/Role'));
Role.preload();
const RoleForm = ReactLazyPreload(() => import('./pages/role/RoleForm'));
RoleForm.preload();
const AgentWallet = ReactLazyPreload(() => import('./pages/agents/AgentWallet'));
AgentWallet.preload();
const BankAccount = ReactLazyPreload(() => import('./pages/agent-bank-accounts/AgentBankAccounts'));
BankAccount.preload();
const BankAccountForm = ReactLazyPreload(() => import('./pages/agent-bank-accounts/AgentBankAccountsForm'));
BankAccountForm.preload();
const DailyAgentDeposit = ReactLazyPreload(() => import('./pages/agent-deposit/DailyAgentDeposit'));
DailyAgentDeposit.preload();
const MonthlyAgentDeposit = ReactLazyPreload(() => import('./pages/agent-deposit/MonthlyAgentDeposit'));
MonthlyAgentDeposit.preload();
const DepositSummaryAgentDeposit = ReactLazyPreload(() => import('./pages/agent-deposit/TransactionSummaryAgentDeposit'));
DepositSummaryAgentDeposit.preload();
const DepositListAgentDeposit = ReactLazyPreload(() => import('./pages/agent-deposit/TransactionListAgentDeposit'));
DepositListAgentDeposit.preload();
const AgentSettlementList = ReactLazyPreload(() => import('./pages/agent-settlement/AgentSettlementList'));
AgentSettlementList.preload();
const AgentSettlementSummary = ReactLazyPreload(() => import('./pages/agent-settlement/AgentSettlementSummary'));
AgentSettlementSummary.preload();
const AgentSettlementForm = ReactLazyPreload(() => import('./pages/agent-settlement/AgentSettlementForm'));
AgentSettlementForm.preload();
const AgentFundOut = ReactLazyPreload(() => import('./pages/agent-fund-out/agent-fund-out-trasaction/AgentFundOut'));
AgentFundOut.preload();
const AgentFundOutSummary = ReactLazyPreload(() => import('./pages/agent-fund-out/agent-fund-out-summary/AgentFundOutSummary'));
AgentFundOutSummary.preload();
const AgentFundOutSummaryMonth = ReactLazyPreload(() => import('./pages/agent-fund-out/agent-fund-out-summary-month/AgentFundOutSummaryMonth'));
AgentFundOutSummary.preload();
const AgentFundOutSummaryDay = ReactLazyPreload(() => import('./pages/agent-fund-out/agent-fund-out-summary-day/AgentFundOutSummaryDay'));
AgentFundOutSummary.preload();
const agentAdjustments = ReactLazyPreload(() => import('./pages/agent-adjustment/AgentAdjustment'));
agentAdjustments.preload();

export const routes: RouteInfo[] = [
    {
        path: "/login",
        component: React.lazy(() => import('./pages/login/Login'))
    }, {
        path: "/agent-management/agent-balance",
        component: AgentWallet,
        protected: true
    },
    {
        path: "/settlement/settlement-list",
        component: AgentSettlementList,
        protected: true
    },
    {
        path: "/settlement/settlement-summary",
        component: AgentSettlementSummary,
        protected: true
    },
    {
        path: "/settlement/add-settlement",
        component: AgentSettlementForm,
        protected: true
    },
    {
        path: "/settlement/edit-settlement/:id",
        component: AgentSettlementForm,
        protected: true
    },
    {
        path: "/deposit/daily-summary",
        component: DailyAgentDeposit,
        protected: true
    },
    {
        path: "/deposit/monthly-summary",
        component: MonthlyAgentDeposit,
        protected: true
    },
    {
        path: "/deposit/transaction-summary",
        component: DepositSummaryAgentDeposit,
        protected: true
    },
    {
        path: "/deposit/transaction-list",
        component: DepositListAgentDeposit,
        protected: true
    },
    {
        path: "/settings/change-password",
        component: ChangePasswords,
        protected: true
    }, {
        path: "/settings/my-account",
        component: MyAccount,
        protected: true
    }, {
        path: "/admin/system-users/edit-system-user/:id",
        component: SystemUserForm,
        protected: true
    }, {
        path: "/admin/system-users/add-system-user",
        component: SystemUserForm,
        protected: true
    }, {
        path: "/admin/user-management",
        component: SystemUser,
        protected: true
    }, {
        path: "/admin/role/edit-role/:id",
        component: RoleForm,
        protected: true
    }, {
        path: "/admin/role/add-role",
        component: RoleForm,
        protected: true
    }, {
        path: "/admin/roles",
        component: Role,
        protected: true
    }, {
        path: "/bank-accounts",
        component: BankAccount,
        protected: true
    }, {
        path: "/adjustment",
        component: agentAdjustments,
        protected: true
    }, {
        path: "/bank-accounts/add-bank-accounts",
        component: BankAccountForm,
        protected: true
    }, {
        path: "/bank-accounts/edit-bank-accounts/:id",
        component: BankAccountForm,
        protected: true
    }, {
        path: "/fundout/transaction-list",
        component: AgentFundOut,
        protected: true
    }, {
        path: "/fundout/transaction-summary",
        component: AgentFundOutSummary,
        protected: true
    }, {            
        path: "/fundout/monthly-summary",
        component: AgentFundOutSummaryMonth,
        protected: true
    }, {
        path: "/fundout/daily-summary",
        component: AgentFundOutSummaryDay,
        protected: true
    }, {
        path: "/dashboard",
        component: Dashboard,
        protected: true
    }, {
        path: "*",
        component: NoMatch
    }
];